import { render, staticRenderFns } from "./tab-bullets-point.html?vue&type=template&id=b8591880&scoped=true&"
import script from "./tab-bullets-point.js?vue&type=script&lang=js&"
export * from "./tab-bullets-point.js?vue&type=script&lang=js&"
import style0 from "./tab-bullets-point.css?vue&type=style&index=0&id=b8591880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8591880",
  null
  
)

export default component.exports